module.exports = __webpack_public_path__ + "static/the-power-868e7b8a6fd2d8f7ee26340736678fcf.jpg";